package one.healthium.base.utils

import androidx.compose.ui.geometry.Size
import kotlinx.browser.window

actual val screenSize: Size
    get() {
        val width = window.screen.width.toFloat()
        val height = window.screen.height.toFloat()
        return Size(width, height)
    }
